module.exports = __webpack_public_path__ + "img/Python.e590897.svg";